
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Soft_tissue_sarcoma_of_abdominal_and_thoracic_visceral_organs",
components: {
XTable
}
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/Soft_tissue_sarcoma_of_abdominal_and_thoracic_visceral_organs.vue